/**
 * Copyright (c) 2015-present, CWB SAS
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
import CommonRoutes from "./common";

export default class extends CommonRoutes {
  dummy(context) {
    this.params = {};
    return { dummy: `route  ${context.req.route.path}` };
  }
}
